// extracted by mini-css-extract-plugin
export default {"container":"src-signer-app-signer-experience-auth-page-layout-module__container--3iKKd"};